import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { ADMIN_NAV } from "@/lib/admin-nav";
import { AdminSettings } from "@/components/admin/AdminSettings";

export const Route = createFileRoute("/admin/settings")({
  head: () => ({ meta: [{ title: "Command Center · Settings" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <ProtectedRoute requiredRole={"admin"}>
      <PortalShell title="Settings" nav={ADMIN_NAV} tourKey="admin_tour">
        <AdminSettings />
      </PortalShell>
    </ProtectedRoute>
  ),
});
